import { useState } from 'react';
import { Accept, useDropzone } from 'react-dropzone';

interface FileInputProps {
  supportFormats: Accept;
  label?: string;
  onChange: (file: File) => void;
  value?: File;
}

export const defaultFormats: Accept = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg'],
  'image/png': ['.png']
};

export const FileInput = ({ onChange, value, label, supportFormats }: FileInputProps) => {
  const [file, setFile] = useState(value);
  const { getRootProps, getInputProps } = useDropzone({
    accept: supportFormats,
    multiple: false,
    onDrop: async (acceptedFiles: File[]) => {
      if (acceptedFiles.length) {
        const selectedFile = acceptedFiles[0];
        setFile(selectedFile);
        if (onChange) {
          onChange(selectedFile);
        }
      }
    }
  });

  return (
    <button {...getRootProps({ className: 'btn btn-light-primary btn-sm' })} type="button">
      <i className="ki-duotone ki-add-files fs-4">
        <i className="path1"></i>
        <i className="path2"></i>
        <i className="path3"></i>
      </i>
      <input {...getInputProps()} />
      {label ?? 'Select a File'}
    </button>
  );
};
